import { controllingSetOpenMenu, controllingSetPresetType } from '../../store/controlling/actions';
import Palette from '../Palette';
import Tools from '../Tools';
import styles from './Menu.module.scss';
import paletteSvg from './assets/palette.svg';
import timeSvg from './assets/time.svg';
import icons from './icons';
import cn from 'classnames';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const types = ['chalk', 'hog', 'sobol', 'rag', 'custom']; // sorted

const Menu = ({ engine }) => {
  const { defaultPresets, presetType, openMenu } = useSelector((s) => s.controlling);
  const { isPremium } = useSelector((s) => s.details);
  const dispatch = useDispatch();

  const [rotations, setRotations] = useState(0);

  const withAnimation = useRef(true);

  const selectOrOpen = (type) => {
    return () => {
      if (openMenu === type) {
        dispatch(controllingSetOpenMenu(undefined));
      } else {
        if (presetType === type) {
          if (openMenu) {
            dispatch(controllingSetOpenMenu(undefined));
          } else {
            withAnimation.current = true;

            dispatch(controllingSetOpenMenu(type));
          }
        } else {
          withAnimation.current = !Boolean(openMenu);

          dispatch(controllingSetPresetType(type));
          dispatch(controllingSetOpenMenu(openMenu ? type : undefined));
        }
      }
    };
  };

  const justOpen = (type) => () => {
    if (openMenu === type) {
      dispatch(controllingSetOpenMenu(undefined));
    } else {
      dispatch(controllingSetOpenMenu(type));
    }
  };

  const justSelect = (type) => () => {
    dispatch(controllingSetOpenMenu(undefined));
    dispatch(controllingSetPresetType(type));
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.menu}>
          <ul>
            {types.map((type) => {
              return (
                <li
                  className={cn(type === presetType && styles.activeTool, openMenu === type && styles.open)}
                  onClick={type === 'custom' ? justSelect(type) : selectOrOpen(type)}
                >
                  <div className={styles.icon}>
                    <img src={type === 'custom' ? icons.custom : icons[defaultPresets[type]]} alt={type} className={styles[`${type}Img`]} />
                  </div>
                </li>
              );
            })}

            <div className={styles.separator} />

            <li
              onClick={() => {
                engine.dry();

                setRotations((r) => r + 1);
              }}
            >
              <div className={cn(styles.icon, styles.time)}>
                <img src={timeSvg} alt="dry" />

                <div
                  style={{
                    transform: `rotate(${rotations * 360}deg)`,
                  }}
                  className={styles.indicator}
                />
              </div>
            </li>

            <div className={styles.separator} />

            <li className={cn(openMenu === 'palette' && styles.open)} onClick={justOpen('palette')}>
              <div className={cn(styles.icon, styles.palette)}>
                <img src={paletteSvg} alt="palette" />
              </div>
            </li>
          </ul>
        </div>
      </div>

      {openMenu === 'palette' && <Palette />}
      {openMenu === 'chalk' && <Tools type="chalk" withAnimation={withAnimation.current} />}
      {openMenu === 'sobol' && <Tools type="sobol" withAnimation={withAnimation.current} />}
      {openMenu === 'hog' && <Tools type="hog" withAnimation={withAnimation.current} />}
      {openMenu === 'rag' && isPremium && <Tools type="rag" withAnimation={withAnimation.current} />}
    </>
  );
};

export default Menu;
